import React from 'react';
import { FaStar, FaCheck, FaWhatsapp } from 'react-icons/fa';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { openWhatsApp } from '../../utils/whatsapp';
import './PackageCard.css';

const PackageCard = ({
  title,
  subtitle,
  description,
  features,
  badge,
  isFeatured = false,
  whatsappMessage
}) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  const handleWhatsAppClick = () => {
    openWhatsApp(title, whatsappMessage);
  };

  return (
    <div
      ref={ref}
      className={`package-card ${isFeatured ? 'featured' : ''} fade-in-section ${isVisible ? 'is-visible' : ''}`}
    >
      {/* Featured Badge */}
      {isFeatured && badge && (
        <div className="package-badge">
          <FaStar />
          {badge}
        </div>
      )}

      {/* Package Header */}
      <div className="package-header">
        <h3 className="package-title">{title}</h3>
        {subtitle && <p className="package-subtitle">{subtitle}</p>}
        {description && (
          <div className="package-description">
            {description}
          </div>
        )}
      </div>

      {/* Package Features */}
      <ul className="package-features">
        {features.map((feature, index) => (
          <li key={index}>
            <span className="feature-checkmark"><FaCheck /></span>
            <span className="feature-text">{feature}</span>
          </li>
        ))}
      </ul>

      {/* WhatsApp Button */}
      <button
        className="btn btn-whatsapp package-btn"
        onClick={handleWhatsAppClick}
        aria-label={`تواصل عبر واتساب لـ ${title}`}
      >
        <FaWhatsapp className="whatsapp-icon" />
        تواصل عبر واتساب
      </button>
    </div>
  );
};

export default PackageCard;
